<!--修改城市运营券使用停车场-->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "../../../commonStructure.vue"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
      return {
        requestBody: {
          "parkCodeList": [
            "PRJ9YJ19"
          ],
          "couponTemplateCode": "8SCM2LLNSDSN",},
        responseCode: {
          "data": {},
          "message": "业务成功",
          "resultCode": 0,
          "status": 1
        },
        infoData: {
          explain: "第三方接入系统请求智慧停车开放平台修改城市运营券模板",
          t_url: this.commonUrls.test+"modifyCityOperationCouponTemplate",
          p_url: this.commonUrls.prod+"modifyCityOperationCouponTemplate",
          precondition: "无",
          fitSystem: "VEMS传统停车场，云停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'parkCodeList', info2: '是', info3: 'String[]', info4: '券适用的停车场列表' },
              { info1: 'couponTemplateCode', info2: '是', info3: 'String', info4: '券模版编码' },
			  { info1: 'coverUrl', info2: '否', info3: 'String', info4: '封面url' },
			  { info1: 'logoUrl', info2: '否', info3: 'String', info4: 'LOGO_URL' }
			
			]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: []
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
            td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
          }],
        }
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/cityOperationCoupon/modifyCityOperationCouponTemplate.vue